import type { ReactElement, ReactNode } from "react";
import { Arbeitsdialog } from "@kundeninfo/ui";
import { Hinweis } from "@kundeninfo/ui/me-design";
import { OBJEKT_TEXT } from "./objektTexte.js";

export type ObjektZustand = { art: "laedt" } | { art: "fehlt"; text: string } | { art: "fehler"; text: string } | { art: "bereit" };

/**
 * Die Hülle eines Objektpanels im Gastgeber: `Arbeitsdialog panel verlauf` (Entscheid 696, F7), rechts angeschlagen oder
 * seitlich neben dem offenen Dialog (F5); der Sprungknopf links unten (Slot `fuss-links`, F11, 109). Öffnet sofort mit der
 * Beschriftung der Stelle als Titel — lädt, fehlt (404: „gibt es nicht (mehr) oder nicht sichtbar“) oder Fehler (F13); der
 * Sprungknopf bleibt in jedem Zustand.
 */
export function ObjektArbeitsdialog(p: { titel: string; seitlich: boolean; sprung: ReactNode; meldungen?: ReactNode; fuss?: ReactNode;
  onAbbrechen: () => void | Promise<void>; abbrechenGesperrt?: boolean; zustand: ObjektZustand; children?: ReactNode }): ReactElement {
  const z = p.zustand;
  return (
    <Arbeitsdialog titel={p.titel} panel="objektpanel" verlauf {...(p.seitlich ? { unter: "seitlich" as const } : {})}
      fussLinks={p.sprung} meldungen={p.meldungen} fuss={p.fuss} onAbbrechen={p.onAbbrechen}
      {...(p.abbrechenGesperrt === undefined ? {} : { abbrechenGesperrt: p.abbrechenGesperrt })}>
      {z.art === "laedt" ? <p role="status">{OBJEKT_TEXT.laedt}</p>
        : z.art === "fehlt" ? <Hinweis art="info">{z.text}</Hinweis>
          : z.art === "fehler" ? <Hinweis art="fehler">{z.text}</Hinweis>
            : p.children}
    </Arbeitsdialog>
  );
}
